/**
 * Storefront wrapper around the validate-discount edge function.
 *
 * This is a preview only. The authoritative discount is recomputed by
 * create-payment-intent; nothing here influences what the card is charged.
 */

export const validateDiscountCode = async ({
  code,
  items,
  shippingOptionId = null,
  shippingCents = 0,
  email = null,
}) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/validate-discount`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      code,
      items: (items || []).map((i) => ({ id: i.id, quantity: i.quantity })),
      // The option *id* is what the server prices from; shippingCents is sent
      // only so an older server still has something to work with. Free shipping
      // covers the standard rate, so the preview of an upgraded option shows
      // the difference the shopper still pays.
      shippingOptionId,
      shippingCents,
      email,
    }),
  });

  if (!response.ok) {
    return { valid: false, reason: 'error', message: "We couldn't check that code. Please try again." };
  }
  return response.json();
};
